export default __webpack_public_path__ + "static/media/career_hero_img.e75408be.png";